module.exports = __webpack_public_path__ + "static/img/quanfu_logo.8b8e017.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quanfu_logo.jpg
// module id = 1369
// module chunks = 0